import template from './details-dialog.html';

export default {
  template,
  controller: 'DetailsDialogController',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/details-dialog/details-dialog.component.js